(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-private-teaser"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STORAGE_PREFIX = 'private-teaser:';
    const SELECTOR = '[data-private-teaser]';

    function getStorage(mode) {
      try {
        if (mode === 'persistent') return window.localStorage;
        if (mode === 'session') return window.sessionStorage;
      } catch (error) {
        return null;
      }

      return null;
    }

    function getStorageKey(root) {
      return `${STORAGE_PREFIX}${root.dataset.privateTeaserId}`;
    }

    function getRequiredCode(root) {
      return (root.dataset.privateTeaserCode || '').trim();
    }

    function getStoredCode(root) {
      const storage = getStorage(root.dataset.privateTeaserStorageMode);
      if (!storage) return '';

      try {
        return storage.getItem(getStorageKey(root)) || '';
      } catch (error) {
        return '';
      }
    }

    function persistCode(root, value) {
      const storage = getStorage(root.dataset.privateTeaserStorageMode);
      if (!storage) return;

      try {
        if (value) {
          storage.setItem(getStorageKey(root), value);
        } else {
          storage.removeItem(getStorageKey(root));
        }
      } catch (error) {
        return;
      }
    }

    function showError(root, message) {
      const errorNode = root.querySelector('[data-private-teaser-error]');
      if (!errorNode) return;

      errorNode.textContent = message;
      errorNode.hidden = !message;
    }

    function renderUnlockedContent(root) {
      if (root.dataset.privateTeaserRendered === 'true') return;

      const contentTarget = root.querySelector('[data-private-teaser-content]');
      const template = root.querySelector('[data-private-teaser-template]');

      if (!contentTarget) return;
      if (!template) {
        root.dataset.privateTeaserRendered = 'true';
        return;
      }

      contentTarget.replaceChildren(template.content.cloneNode(true));
      root.dataset.privateTeaserRendered = 'true';
    }

    function setState(root, unlocked) {
      const locked = root.querySelector('[data-private-teaser-locked]');
      const unlockedNode = root.querySelector('[data-private-teaser-unlocked]');

      if (unlocked) {
        renderUnlockedContent(root);
      }

      root.dataset.privateTeaserState = unlocked ? 'unlocked' : 'locked';

      if (locked) locked.hidden = unlocked;
      if (unlockedNode) unlockedNode.hidden = !unlocked;

      if (unlocked) {
        showError(root, '');
      }
    }

    function unlockIfRemembered(root) {
      const requiredCode = getRequiredCode(root);

      if (!requiredCode) {
        setState(root, true);
        return;
      }

      setState(root, getStoredCode(root) === requiredCode);
    }

    function handleSubmit(root) {
      const input = root.querySelector('[data-private-teaser-input]');
      if (!input) return;

      const attempt = input.value.trim();
      const requiredCode = getRequiredCode(root);

      if (requiredCode && attempt === requiredCode) {
        persistCode(root, requiredCode);
        setState(root, true);
        input.value = '';
        return;
      }

      persistCode(root, '');
      setState(root, false);
      showError(root, root.dataset.privateTeaserErrorMessage || '');
      input.focus();
    }

    function getZoomColorScheme(root) {
      return Array.from(root.classList).find((className) => className.startsWith('color-')) || '';
    }

    function getZoomTriggers(root) {
      return Array.from(root.querySelectorAll('[data-private-teaser-zoom-image]'));
    }

    function openZoom(root, trigger) {
      if (!window.theme || typeof window.theme.LoadPhotoswipe !== 'function') return;

      const triggers = getZoomTriggers(root);
      const index = triggers.indexOf(trigger);

      if (index < 0) return;

      const items = triggers
        .map((node) => ({
          src: node.getAttribute('data-image-src'),
          w: parseInt(node.getAttribute('data-image-width'), 10),
          h: parseInt(node.getAttribute('data-image-height'), 10),
          msrc: node.getAttribute('data-image-src'),
        }))
        .filter((item) => item.src && item.w > 0 && item.h > 0);

      if (!items.length) return;

      const colorScheme = getZoomColorScheme(root);

      window.a11y.lastElement = trigger;
      new window.theme.LoadPhotoswipe(items, {
        history: false,
        focus: false,
        index,
        mainClass: `pswp-zoom-gallery pswp-private-teaser-gallery${items.length === 1 ? ' pswp-zoom-gallery--single' : ''}${colorScheme ? ` ${colorScheme}` : ''}`,
        showHideOpacity: true,
        showAnimationDuration: 150,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        captionEl: true,
        closeEl: true,
        closeElClasses: ['caption-close', 'title'],
        tapToClose: false,
        clickToCloseNonZoomable: false,
        maxSpreadZoom: 2,
        loop: true,
        spacing: 0,
        allowPanToNext: true,
        pinchToClose: false,
        addCaptionHTMLFn: (item, captionEl) => {
          const captionCenter = captionEl && captionEl.children && captionEl.children[0];

          if (captionCenter) {
            captionCenter.innerHTML = '';
          }

          return false;
        },
        getThumbBoundsFn: () => {
          const bounds = trigger.getBoundingClientRect();
          const scrollTop = window.scrollY || document.documentElement.scrollTop;

          return { x: bounds.left, y: bounds.top + scrollTop, w: bounds.width };
        },
      });
    }

    function bindInstance(root) {
      if (!root || root.dataset.privateTeaserBound === 'true') return;

      root.dataset.privateTeaserBound = 'true';

      const form = root.querySelector('[data-private-teaser-form]');
      const input = root.querySelector('[data-private-teaser-input]');

      unlockIfRemembered(root);

      root.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-private-teaser-zoom-image]');
        if (!trigger || !root.contains(trigger)) return;

        event.preventDefault();
        openZoom(root, trigger);
      });

      root.addEventListener('keyup', (event) => {
        if (event.code !== 'Enter' && event.code !== 'Space') return;

        const trigger = event.target.closest('[data-private-teaser-zoom-image]');
        if (!trigger || !root.contains(trigger)) return;

        event.preventDefault();
        openZoom(root, trigger);
      });

      if (!form) return;

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        handleSubmit(root);
      });

      if (input) {
        input.addEventListener('input', () => showError(root, ''));
      }
    }

    function initPrivateTeasers(container = document) {
      container.querySelectorAll(SELECTOR).forEach(bindInstance);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initPrivateTeasers(document));
    } else {
      initPrivateTeasers(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initPrivateTeasers(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
